import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Target, ShieldCheck, Zap } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="bg-[#F8FAFC] min-h-screen font-['Onest'] text-slate-900">
      {/* Navbar Simple */}
      <nav className="bg-white border-b border-slate-100 h-20 flex items-center">
        <div className="container mx-auto px-6">
          <Link to="/" className="text-4xl font-semibold text-emerald-800">mikropedia</Link>
        </div>
      </nav>

      <main className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-black text-slate-900 mb-8 leading-tight">
            Memberdayakan <span className="text-emerald-700">Ekonomi Lokal</span> Melalui Ide Kreatif.
          </h1>
          
          <p className="text-lg text-slate-600 mb-12 leading-relaxed">
            Mikropedia hadir sebagai jembatan bagi calon wirausahawan untuk menemukan peluang bisnis mikro yang relevan, 
            terjangkau, dan berkelanjutan di era digital. Kami percaya bahwa setiap orang berhak memiliki akses 
            ke panduan bisnis yang berkualitas.
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-20">
            {[
              { icon: <Target className="text-emerald-700" />, title: "Visi Kami", desc: "Menjadi platform rujukan nomor satu bagi UMKM Indonesia dalam mencari inspirasi usaha." },
              { icon: <Zap className="text-emerald-700" />, title: "Misi Kami", desc: "Menyediakan kurasi ide bisnis dengan rincian modal yang transparan dan mudah dipahami." }
            ].map((item, i) => (
              <div key={i} className="bg-white p-8 rounded-[2rem] border border-slate-100 shadow-sm">
                <div className="mb-4">{item.icon}</div>
                <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="bg-emerald-800 rounded-[2.5rem] p-10 md:p-16 text-white text-center">
            <h2 className="text-3xl font-bold mb-4">Mari Berkolaborasi</h2>
            <p className="opacity-80 mb-8 max-w-xl mx-auto">Kami terbuka untuk kerja sama dengan komunitas, mentor bisnis, maupun investor yang ingin memajukan UMKM Indonesia.</p>
            <Link to="/contact" className="inline-block bg-white text-emerald-800 px-8 py-4 rounded-2xl font-bold hover:bg-slate-100 transition-all">
              Hubungi Tim Kami
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AboutPage;